import { useCommonStore } from '~/stores/common';
import { routeMap } from '~/utils/router';
import { useUserStore } from '~/stores/user';
import { useAuthToken } from '~/utils/token';

export const useHomePage = () => {
    const commonStore = useCommonStore();
    const userStore = useUserStore();
    const { brand } = useAuthToken();

    const defaultHomePage = import.meta.env.VITE_HOMEPAGE;
    const IMDefaultHomePage = import.meta.env.VITE_IM_HOMEPAGE;
    const fallbackHomePage = import.meta.env.VITE_HOMEPAGE_FALLBACK;

    const homepage = computed(() => {
        // if(userStore.userInfo?.username==="5000SSNW12"){
        //     return '/Information/Homepage'
        // }else{
        //      routeMap.has(defaultHomePage) ? defaultHomePage : fallbackHomePage,
        // }

        const isInfo = ref<boolean>(false);
        isInfo.value = brand.value === 'INFO';
        return isInfo.value && brand.value === 'INFO'
            ? '/Information/Homepage'
            : routeMap.has(defaultHomePage)
                ? defaultHomePage
                : fallbackHomePage;
    });
    console.log(homepage, ';homepage');

    return {
        homepage,
    };
};
